import { handleAddEventBoardView } from '@/utilities/moveCard';
import { getSprintKey, getSprintListKey } from '@/utilities/sprintKeys';
import { useStore } from 'vuex';

export default function useMoveCard() {
  const store = useStore();

  const moveCardToDifferentList = async (listId: string, cardId: string) => {
    const card = store.getters.getCards[cardId];
    if (!card) {
      return Promise.resolve();
    }

    const newIndex = 0;
    const cardParentId = card.sprint_id
      ? getSprintKey(card.project_id, card.sprint_id)
      : card.board_id;
    const oldIndex = store.getters.boardsListsIds[cardParentId].findIndex(
      (id: string) => id === card.id
    );
    const originalListId = card.list_id;

    handleAddEventBoardView({
      newIndex,
      oldIndex,
      cardId: card.id,
      listId,
      originalListId: card.sprint_id
        ? getSprintListKey(card.project_id, card.sprint_id, card.list_id)
        : card.list_id,
      destinationBoardId: cardParentId,
      originalBoardId: cardParentId,
      storeGetters: store.getters as any,
      storeDispatch: store.dispatch as any,
      originalProjectId: card.project_id,
      destinationProjectId: card.project_id,
    });

    const listIdForReq = card.sprint_id ? store.getters.lists[listId].orginalId : listId;

    return store
      .dispatch('updateCard', {
        cardId: card.id,
        card: {
          position: newIndex,
          list_id: listIdForReq,
          ...(card.sprint_id && { sprint_id: card.sprint_id }),
          ...(card.sprint_id && { project_id: card.project_id }),
        },
        oldListId: card.sprint_id
          ? getSprintListKey(card.project_id, card.sprint_id, originalListId)
          : originalListId,
        type: card.type,
      })
      .then(({ data }) => {
        const list_id = data.card?.sprint_id ? data.card.list_id : data.epic?.list_id;
        if (list_id) {
          store.dispatch('localUpdateCardField', {
            cardId,
            fieldName: 'list_id',
            fieldValue: list_id,
          });
        }
        return data;
      })
      .catch(() => {
        handleAddEventBoardView({
          newIndex: oldIndex,
          oldIndex: newIndex,
          cardId: card.id,
          listId: originalListId,
          originalListId: listId,
          destinationBoardId: cardParentId,
          originalBoardId: cardParentId,
          storeGetters: store.getters,
          storeDispatch: store.dispatch,
          originalProjectId: card.project_id,
          destinationProjectId: card.project_id,
        });
      });
  };

  return {
    moveCardToDifferentList,
  };
}
